import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Quote } from "lucide-react";
import { FadeUp } from "@/components/Reveal";

const TESTIMONIALS = [
  {
    quote: "Prompt, precise and always a step ahead — exactly what you want from counsel.",
    source: "Corporate Client, Logistics Sector",
  },
  {
    quote: "Clear advice, honest timelines, and monthly reports we can actually rely on.",
    source: "Corporate Client, Manufacturing",
  },
  {
    quote: "They resolved a long-standing tax matter with professionalism at every step.",
    source: "Corporate Client, Trading & Distribution",
  },
];

export default function Testimonials() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setIndex((i) => (i + 1) % TESTIMONIALS.length), 6000);
    return () => clearInterval(id);
  }, []);

  const t = TESTIMONIALS[index];

  return (
    <section
      data-testid="testimonials-section"
      className="relative py-16 lg:py-20 border-b border-gold/10"
    >
      <div className="max-w-3xl mx-auto px-6 text-center">
        <FadeUp>
          <Quote size={22} className="mx-auto text-gold/60" />
          <div className="min-h-[7rem] flex items-center justify-center">
            <AnimatePresence mode="wait">
              <motion.figure
                key={index}
                initial={{ opacity: 0, y: 14 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -14 }}
                transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
                data-testid="testimonial-quote"
              >
                <blockquote className="font-editorial italic text-xl sm:text-2xl text-ink leading-relaxed">
                  "{t.quote}"
                </blockquote>
                <figcaption className="font-mono text-[11px] uppercase tracking-[0.25em] text-gold mt-5">
                  {t.source}
                </figcaption>
              </motion.figure>
            </AnimatePresence>
          </div>
          <div className="flex items-center justify-center gap-2 mt-4">
            {TESTIMONIALS.map((_, i) => (
              <button
                key={i}
                data-testid={`testimonial-dot-${i}`}
                onClick={() => setIndex(i)}
                aria-label={`Show testimonial ${i + 1}`}
                className={`h-1.5 rounded-full transition-all duration-300 ${
                  i === index ? "w-6 bg-gold" : "w-1.5 bg-gold/25 hover:bg-gold/50"
                }`}
              />
            ))}
          </div>
        </FadeUp>
      </div>
    </section>
  );
}
